"use client";

import { useSyncExternalStore } from "react";
import { useRouter } from "next/navigation";
import { LeftOutlined } from "@ant-design/icons";

/**
 * ガイドのヘッダーの「戻る」。アプリ内から開いたときは元の画面へ戻し、
 * 直接開いたとき (履歴が無いとき) はログイン画面へ移動する。
 */
export function GuideBackButton() {
  const router = useRouter();
  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push("/");
    }
  };
  return (
    <button
      type="button"
      onClick={handleBack}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        border: "1px solid var(--color-border-soft, #d6d6d6)",
        borderRadius: 999,
        background: "#fff",
        color: "var(--color-text-primary, #3a3a3a)",
        fontSize: 12,
        padding: "5px 12px",
        cursor: "pointer",
        minHeight: 32,
      }}
    >
      <LeftOutlined style={{ fontSize: 10 }} />
      戻る
    </button>
  );
}

const subscribeNothing = () => () => {};

/** いま開いているアプリの URL (例: https://dev.icg-app.fan-mily.com)。サーバー描画時は出さない */
export function CurrentAppUrl({ path = "" }: { path?: string }) {
  const origin = useSyncExternalStore(
    subscribeNothing,
    () => window.location.origin,
    () => null,
  );
  if (!origin) return null;
  return (
    <span
      style={{
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        fontSize: 13,
        background: "#f3f3f3",
        borderRadius: 4,
        padding: "1px 5px",
        wordBreak: "break-all",
      }}
    >
      {origin}
      {path}
    </span>
  );
}
